import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "pages.registration" */ /* webpackPrefetch: true */
      './CollaboratorsPage.component'
    ),
);
